import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAmwayLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 32,
	viewBox: "0 0 30 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M29.5384 27.8235L29.2275 28.6635L0 32L1.16598 29.8683L29.5384 27.8235ZM14.6475 5.21262L17.0552 14.36H12.3651L14.6475 5.21262ZM17.4301 0H11.8019L4.26631 23.7427H9.80086L11.2078 18.6976H18.2747L19.7131 23.7427H25.2787L17.4301 0Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgIconAmwayLogo);
export { ForwardRef as ReactComponent };
